module.exports = __webpack_public_path__ + "img/black-cumin.12d41d96.jpg";